<template>
  <v-container>
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col sm="3">
        {{ payload.titulo }}
      </v-col>

      <v-col sm="3">
        <v-select
          id="tipo-execucao-select"
          v-if="
            estado === 'SC' ||
            estado === 'MS' ||
            estado === 'SP' ||
            estado === 'BA' ||
            estado === 'MA'
          "
          v-model="payload.tipoExecucaoRelatorio"
          item-text="name"
          item-name="value"
          item-value="value"
          :items="tiposExecucao"
          label="Execução"
          :readonly="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        >
        </v-select>
      </v-col>

      <v-col sm="2" offset-sm="4" class="text-right">
        <v-btn
          v-if="
            (isAdmin ||
              user.usuarioId === payload.usuarioId ||
              isSPFesp ||
              isSPFespEspecial ||
              isSPCoordenador) &&
            payload.statusRelatorioId != 2 &&
            payload.statusRelatorioId != 4
          "
          outlined
          color="primary"
          class="ml-3"
          @click="update()"
        >
          <span>Atualizar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="3">
        <v-text-field
          v-if="
            estado === 'SC' ||
            estado === 'MS' ||
            estado === 'SP' ||
            estado === 'BA' ||
            estado === 'MA' ||
            estado === 'RJ'
          "
          v-model="payload.inicioString"
          v-mask="'##/##/#### ##:##'"
          label="Data de Início"
          placeholder="00/00/0000 00:00"
          disabled
        ></v-text-field>
      </v-col>

      <v-col sm="3">
        <v-text-field
          v-if="
            estado === 'SC' ||
            estado === 'MS' ||
            estado === 'SP' ||
            estado === 'BA' ||
            estado === 'MA' ||
            estado === 'RJ'
          "
          v-model="payload.fimString"
          v-mask="'##/##/#### ##:##'"
          label="Data de Término"
          placeholder="00/00/0000 00:00"
          disabled
        ></v-text-field>
      </v-col>

      <v-col sm="3">
        <v-text-field
          v-if="
            estado === 'SC' ||
            estado === 'MS' ||
            estado === 'SP' ||
            estado === 'BA' ||
            estado === 'MA' ||
            estado === 'RJ'
          "
          v-model="payload.horasUtilizadasString"
          v-mask="'##:##'"
          label="Horas Utilizadas"
          placeholder="00:00"
          :disabled="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-file-chart</v-icon>
          Relatório
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-multiple-plus</v-icon>
          Convidados
        </v-tab>
        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          Anexos
        </v-tab>
        <v-tab
          v-if="
            estado === 'SC' ||
            estado === 'MS' ||
            estado === 'SP' ||
            estado === 'BA' ||
            estado === 'MA' ||
            estado === 'RJ'
          "
        >
          <v-icon left>mdi-calendar-check-outline</v-icon>
          Tarefas
        </v-tab>
        <v-tab>
          <v-icon left>mdi-android-messages</v-icon>
          Observações
        </v-tab>

        <v-tab-item>
          <v-col>
            <v-textarea
              v-model="payload.descricao"
              :readonly="
                payload.statusRelatorioId === 2 ||
                payload.statusRelatorioId === 4
              "
            ></v-textarea>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <app-modal-insert-member
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :municipioId="payload.municipioId"
              @onSave="getMembers"
              v-if="
                (isAdmin ||
                  user.usuarioId === payload.usuarioId ||
                  isSPFesp ||
                  isSPFespEspecial ||
                  isSPCoordenador) &&
                payload.statusRelatorioId != 2 &&
                payload.statusRelatorioId != 4
              "
            >
              <template v-slot:title :edit="false"> Cadastrar Membro </template>
            </app-modal-insert-member>
          </v-col>

          <v-col>
            <v-combobox
              v-model="payload.convidadosRelatorio"
              :items="membros"
              chips
              clearable
              label="Membros"
              item-value="membroId"
              multiple
              :readonly="
                payload.statusRelatorioId === 2 ||
                payload.statusRelatorioId === 4
              "
            >
              <template v-slot:item="{ attrs, item }">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ item.nome | esconderValores("nome") }}
              </template>
              <template v-slot:selection="{ attrs, item }">
                <v-chip close @click:close="removeMembro(item)">
                  <strong
                    >{{ item.nome | esconderValores("nome") }} -
                    {{ item.cpf | esconderValores("cpf") }}</strong
                  >
                </v-chip>
              </template>
            </v-combobox>
          </v-col>

          <v-data-table
            :headers="headersConvidados"
            :items="payload.convidadosRelatorio"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.presente="{ item }">
              <v-checkbox
                v-model="item.presente"
                :id="'membro' + item.membroId"
                color="primary"
                :disabled="
                  payload.statusRelatorioId === 2 ||
                  payload.statusRelatorioId === 4
                "
              >
              </v-checkbox>
            </template>

            <template v-slot:item.cpf="{ item }">
              {{ item.cpf | esconderValores("cpf") }}
            </template>
            <template v-slot:item.email="{ item }">
              {{ item.email | esconderValores("email") }}
            </template>

            <template v-slot:item.nome="{ item }">
              {{ item.nome | esconderValores("nome") }}
            </template>

            <template slot="no-data">
              <span> Nenhum convidado retornado </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-col
            v-if="
              payload.statusRelatorioId !== 2 && payload.statusRelatorioId !== 4
            "
          >
            <template>
              <v-file-input
                multiple
                label="File input"
                v-model="payload.arquivos"
              >
              </v-file-input>
            </template>
          </v-col>
          <v-data-table
            :headers="headersAnexos"
            :items="payload.anexos"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.download="{ item }">
              <v-btn
                outlined
                color="primary"
                class="ml-3"
                @click="downloadAnexo(item)"
              >
                <span>Download</span>
              </v-btn>
              <v-btn
                outlined
                color="primary"
                class="ml-3"
                @click="ExcluirAnexo(item)"
              >
                <span>Excluir</span>
              </v-btn>
            </template>

            <template slot="no-data">
              <span> Nenhum anexo retornado </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item
          v-if="
            estado === 'SC' ||
            estado === 'MS' ||
            estado === 'SP' ||
            estado === 'BA' ||
            estado === 'MA'
          "
        >
          <v-data-table
            :headers="headers"
            :items="payload.tarefas"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:top>
              <v-col
                class="text-right"
                v-if="
                  (isAdmin ||
                    user.usuarioId === payload.usuarioId ||
                    isSPFesp ||
                    isSPFespEspecial ||
                    isSPCoordenador) &&
                  payload.statusRelatorioId != 2 &&
                  payload.statusRelatorioId != 4
                "
              >
                <app-modal-insert-task @onAddTask="addTask">
                </app-modal-insert-task>
              </v-col>
            </template>
            <template v-slot:item.cumprida="{ item }">
              <v-checkbox
                v-model="item.cumprida"
                :id="'cumprida' + item.tarefaId"
                color="primary"
                :disabled="
                  payload.statusRelatorioId === 2 ||
                  payload.statusRelatorioId === 4
                "
              >
              </v-checkbox>
            </template>
            <template
              v-slot:item.tarefa.municipioTarefa.municipioEvidencias="{ item }"
            >
              <span
                v-for="evidencia in item.municipioTarefa.municipioEvidencias"
                :key="evidencia.municipioEvidenciaId"
              >
                {{ evidencia.nome }} |
              </span>
            </template>

            <template slot="no-data">
              <span> Nenhuma tarefa retornada </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <v-textarea
              v-model="payload.observacoes"
              :readonly="!(isAdmin || payload.usuarioId === user.usuarioId)"
            ></v-textarea>
          </v-col>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { reportAPI } from "@/modules/report";
import { AppCityHeader } from "@/modules/city";
import { memberAPI } from "@/modules/city/components/MemberAPI";
import AppModalInsertMember from "@/modules/city/components/group/ModalInsertMember";
import AppModalInsertTask from "./ModalInsertTask";

export default {
  components: {
    AppCityHeader,
    AppModalInsertMember,
    AppModalInsertTask,
  },
  data() {
    return {
      tiposExecucao: [
        { name: "Presencial", value: 1 },
        { name: "Remoto", value: 2 },
      ],
      payload: {
        arquivos: [],
        convidadosRelatorio: [],
        tarefas: [],
        tipoExecucaoRelatorio: { name: "Presencial", values: 1 },
      },
      membros: [],
      headers: [
        { text: "Tarefa", value: "municipioTarefa.nome" },
        { text: "Cumprida", value: "cumprida" },
        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
      ],
      headersConvidados: [
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
        { text: "E-mail", value: "email" },
        { text: "Presente", value: "presente" },
      ],
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
      estado: this.$store.state.uf,
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    get() {
      this.setLoading(true);
      reportAPI
        .get(this.$route.params.relatorio)
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
          this.payload.tipoExecucaoRelatorio = this.tiposExecucao.find(
            (item) => item.value === this.payload.tipoExecucaoRelatorioId
          );
          this.getMembers();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório");
        });
    },
    downloadAnexo(evidencia) {
      reportAPI
        .downloadAnexo(evidencia.relatorioAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter evidencia");
        });
    },
    ExcluirAnexo(evidencia) {
      memberAPI
        .deleteAnexoById(evidencia.relatorioAnexoId)
        .then((resp) => {
          this.get();
          this.$notification.success("Anexo Excluido");
        })
        .catch((resp) => {
          // this.$notification.error('Erro ao atualizar relatório')
          this.$notification.success("Anexo Excluido");
        });
    },
    update() {
      this.setLoading(true);
      let formData = new FormData();

      if (this.payload.arquivos) {
        for (let i = 0; i < this.payload.arquivos.length; i++) {
          formData.append("arquivos", this.payload.arquivos[i]);
        }
      }

      formData.append("criacao", this.payload.criacao);
      formData.append("descricao", this.payload.descricao);
      formData.append("encontroId", this.payload.encontroId);
      formData.append("usuarioId", this.payload.usuarioId);
      formData.append("municipioId", this.payload.municipioId);
      formData.append("relatorioId", this.payload.relatorioId);
      formData.append("statusRelatorioId", this.payload.statusRelatorioId);
      formData.append("titulo", this.payload.titulo);
      formData.append(
        "tipoExecucaoRelatorioId",
        this.payload.tipoExecucaoRelatorio.value
      );
      formData.append(
        "horasPrevistasString",
        this.payload.horasPrevistasString
      );
      formData.append(
        "horasUtilizadasString",
        this.payload.horasUtilizadasString
      );
      formData.append("inicioString", this.payload.inicioString);
      formData.append("fimString", this.payload.fimString);
      formData.append("criacaoString", this.payload.criacaoString);
      formData.append(
        "tarefasRelatorioString",
        JSON.stringify(this.payload.tarefas)
      );
      formData.append(
        "convidadosRelatorioString",
        JSON.stringify(this.payload.convidadosRelatorio)
      );
      formData.append(
        "convidadosString",
        JSON.stringify(this.payload.convidados)
      );
      if (this.payload.observacoes) {
        formData.append("observacoes", this.payload.observacoes);
      }
      if (this.payload.motivoRejeicao) {
        formData.append("motivoRejeicao", this.payload.motivoRejeicao);
      }
      if (this.payload.complemento) {
        formData.append("complemento", this.payload.complemento);
      }

      reportAPI
        .update(formData)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Relatório Atualizado");
        })
        .catch((resp) => {
          this.setLoading(false);
          // this.$notification.error('Erro ao atualizar relatório')
          this.$notification.success("Relatório Atualizado");
        });
    },
    getMembers() {
      this.setLoading(true);
      memberAPI
        .getMembersByCity(this.$route.params.id)
        .then((resp) => {
          this.membros = resp.data;
          this.onMemberClick();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    addTask(tasks) {
      for (let count = 0; count < tasks.length; count++) {
        this.payload.tarefas.push({
          municipioTarefa: tasks[count],
          municipioTarefaId: tasks[count].municipioTarefaId,
          cumprida: true,
        });
      }
    },
    onMemberClick() {
      for (let count = 0; count < this.membros.length; count++) {
        this.membros[count].presente = true;
      }
    },
  },
  mounted() {
    this.get();
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "user",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
    ]),
  },
};
</script>
